import React from 'react';

import { withEventScope } from '@repo/event-processor';

import { FlexColumn } from 'styles/layouts';

import { SmallHeading } from '../../AiTools/styles';

import PresetCardRow from './PresetCards/PresetCardRow';
import { PresetsWrapper } from './styles';
import { PresetsProps } from './types';

const Presets: React.FC<PresetsProps> = ({
  activePresetId,
  presets,
  onPresetClick,
}) => {
  return (
    <PresetsWrapper>
      {presets.map(({ id, label, presets }) => (
        <FlexColumn key={id} gap="16px">
          <SmallHeading>{label}</SmallHeading>
          <PresetCardRow
            activePresetId={activePresetId}
            presets={presets}
            onPresetClick={onPresetClick}
          />
        </FlexColumn>
      ))}
    </PresetsWrapper>
  );
};

export default withEventScope(Presets, { module: 'presets' });
